import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20fantasy%20dungeon%20entrance%20with%20massive%20stone%20archway%20lit%20by%20flickering%20torches%2C%20ancient%20ruins%20with%20moss-covered%20pillars%2C%20mysterious%20warm%20amber%20light%20spilling%20from%20deep%20within%20the%20cave%2C%20atmospheric%20game%20concept%20art%20with%20cinematic%20composition%2C%20rich%20dark%20brown%20and%20gold%20tones%2C%20painterly%20textures&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="哥布林的洞窟 - 黑暗地下世界"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 md:mb-6 leading-tight text-balance">
          探索<strong className="text-primary-400">哥布林的洞窟</strong>
        </h1>
        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-6 md:mb-8 leading-relaxed">
          哥布林的洞窟是一个充满神秘与危险的地下冒险世界。从新手攻略到终极BOSS战，
          我们为你提供最全面的游戏指南，助你在这片黑暗洞穴中生存并称霸。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <Link
            to="/category/beginner-guide"
            className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-compass-3-line mr-2"></i>开始冒险
          </Link>
          <Link
            to="/category/boss-guide"
            className="w-full sm:w-auto px-8 py-3 bg-background-50/15 text-background-50 border border-background-50/30 rounded-md font-medium text-sm whitespace-nowrap hover:bg-background-50/25 transition-colors cursor-pointer"
          >
            <i className="ri-sword-line mr-2"></i>BOSS攻略
          </Link>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-background-50/40 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 bg-background-50/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}